import { ConversationList } from "./ConversationsList"
import { useGetConversationsItemsQuery } from "@apis/conversations/useConversations"

type TConversationsProps = {
  conversationId: string
  xref_id: string
}

export const Conversations = ({
  conversationId,
  xref_id,
}: TConversationsProps) => {
  const {
    data: conversations = [],
    isError,
    error,
    isPending,
  } = useGetConversationsItemsQuery(conversationId)

  if (isPending)
    return <div className="tw:p-8 tw:text-center">Loading Conversations…</div>

  if (isError)
    return (
      <div className="tw:p-8 tw:text-red-500">
        Error loading conversations: {(error as Error).message}
      </div>
    )

  return (
    <div className="tw:flex tw:flex-col tw:gap-6">
      <div className="tw:overflow-y-auto">
        <ConversationList
          conversation_items={conversations}
          inspire_conversation_id={conversationId}
          gladly_conversation_id={xref_id}
        />
      </div>
    </div>
  )
}
